import { render, staticRenderFns } from "./ProjectTitleComponent.vue?vue&type=template&id=432edc3b"
import script from "./ProjectTitleComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectTitleComponent.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTitleComponent.vue?vue&type=style&index=0&id=432edc3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports